<!-- Listagem inicial do cadastro de participantes

-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CustomerForm from './customer-form'
import GrucliList from './grucli-list.vue'
import GruforList from './grufor-list'
import { getText, formatDate, formatValue, formatCNPJCPF } from '../shared/utils'
import { SysVars } from '../main';
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0,
            offset: false,
            moreActionsBarList: [
                { action: 0, label: 'Importar Clientes' },
            ]
        }
    },

    computed: {
        partList: function () {
            return this.$store.getters.getPartList
        },

        nextPage: function () {
            return this.$store.getters.getNextPage
        },

       tabs: function () {
            return [
                { title: 'Clientes', icon: 'fa-users' },
                { title: 'Grupo de Cliente', icon: 'fa-user' },
                { title: 'Grupo de Fornecedor', icon: 'fa-cubes' }
            ]
        },

        tabClientes: function () {
            return this.activeTab == 0
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupoCli: function () {
            return this.activeTab == 1
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupoForn: function () {
            return this.activeTab == 2
        },
    },

    methods: {
        textTipo(cli, forn, tra) {
            let text = ''
            if (cli=='S') text = 'Cliente'
            if (forn=='S') text = text + ' Fornecedor'
            if (tra=='S') text = text + ' Transportadora'
            return text
        },

        textContricms (value) {
            return getText(value, this.metadata.part.contricms)
        },

        situacao (part) {
            if (part.stpart == 'I') {
                return 'Inativo';
            }
            if (part.cliente == 'S') {
                if (part.stcred == 'B') {
                    return 'Crédito Bloqueado';
                }
                if (part.stcred == 'A') {
                    return 'Somente Venda a Vista';
                }
                return 'Crédito Liberado';
            }
            return '';
        },

        situacaoBadgeClass (part) {
            if (part.stpart == 'I' || (part.cliente == 'S' && part.stcred == 'B')) {
                return 'nb-card-badge--danger';
            }
            if (part.cliente == 'S' && part.stcred == 'A') {
                return 'nb-card-badge--warning';
            }
            return 'nb-card-badge--success';
        },

        async handleAction(act) {
            if (act == 0) {
                //importação de cadastro de clientes
                this.$router.push('/importa/clientes')
            }
            if (act == 'xls') {
                while (this.nextPage){
                  await this.handleMore(true);
                }
                const data = this.partList
                .map(it => {

                    let obj = {
                                codigo: it.codpart,
                                nome: it.nome,
                                fantasia: it.fantasia,
                                cnpjcpf: formatCNPJCPF(it.cnpjcpf),
                                email: it.email,
                                inscricao_estadual: it.iest,
                                tipo: this.textTipo(it.cliente, it.forn, it.transp),
                                st: it.stpart,
                    }

                    return obj
                })
                if (!data || data.length == 0)
                this.$erpToastError('Nenhum participante para visualizar')
                else {
                    const csv = objectToCsv(data)
                    downloadCsvReport(csv)
                }
            }
        },

        textoptsimples (value) {
            return getText(value, this.metadata.part.optsimples)
        },

        editPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //update
            this.codpart = codpart
            this.showForm = true;
        },

        incluirPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudI
            this.codpart = codpart
            this.showForm = true;
        },

        onAction (action) {

        },

        closeForm () {
            this.showForm = false
            this.loadData()
        },

        search (value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value.toUpperCase() + '%25"}},{"fantasia":{"$like":"%25' + value.toUpperCase() + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}'
            // this.filter = '{"nome":{"$like":"' + value + '%25"}}'
            this.loadData()
        },

        async loadData (wait) {
            let params = { filter: this.filter }

            if (this.offset) {
                params.offset = this.nextPage
            }

            if (wait){
              await this.$store.dispatch('loadPart', params )
            }else{
              this.$store.dispatch('loadPart', params )
            }

            this.offset = false


        },

        async handleMore (wait) {
            this.offset = true
            await this.loadData(wait)
        },


        scroll () {
          window.onscroll = () => {
            if (this.showForm || this.offset || this.nextPage == 0)
              return
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

            if (bottomOfWindow) {
              this.offset = true
              this.loadData()
            }
            SysVars.scrollPosition = document.documentElement.scrollTop
          }
        },

        changeTab (idx) {
            this.activeTab = idx
        },
    },

    components: {
        BarList, BarGrid, CustomerForm, GrucliList, GruforList
    },

    mounted () {
      this.scroll()
    },

    created () {
        this.showForm = false
        this.loadData()
    },

    destroyed () {
        window.onscroll = null
    },


}

</script>

<template>
    <div id="grid">
        <div id="list" v-show="!showForm">

            <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab" class="pb-5"></tabs>

            <bar-list
                v-if="!tabGrupoCli && !tabGrupoForn"
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="true"
                single-entity="Participante (Cliente, Fornecedor e Transportadora)"
                plural-entity="Participantes (Clientes, Fornecedores e Transportadoras)"
                :moreActions="moreActionsBarList"
                @action="handleAction"
                @search="search"
                @new="incluirPart"
                @refresh="loadData"
                title-search="Pesquise pelo nome, nome fantasia, código, cnpj ou cpf">
            </bar-list>

            <div class="nb-margin-top">
                <!-- Grupo Cliente -->
                <transition v-if="tabGrupoCli">
                    <grucli-list></grucli-list>
                </transition>

                <!-- Grupo Fornecedor -->
                <transition v-if="tabGrupoForn">
                    <grufor-list></grufor-list>
                </transition>
            </div>

            <div v-if="tabClientes" class="default-container nb-card-list">
                <alert v-if="partList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="part in partList" :key="part.codpart">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i :class="(part.cnpjcpf && part.cnpjcpf.length > 11) ? 'fa fa-building-o' : 'fa fa-user'" aria-hidden="true"></i>
                            </div>

                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ part.nome }}</h2>
                                    <span v-if="situacao(part)" class="nb-card-badge" :class="situacaoBadgeClass(part)">
                                        {{ situacao(part) }}
                                    </span>
                                    <span v-if="textTipo(part.cliente, part.forn, part.transp)" class="nb-card-badge nb-card-badge--info">
                                        {{ textTipo(part.cliente, part.forn, part.transp) }}
                                    </span>
                                </div>
                                <div class="nb-card-subtitle">
                                    <span v-if="part.fantasia" class="mr-2">{{ part.fantasia }}</span>
                                    <span v-if="part.cnpjcpf" class="mr-2 font-weight-bold">{{ part.cnpjcpf | formatCNPJCPF }}</span>
                                    <span class="nb-card-code">Código <strong>{{ part.codpart }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' }"
                                :moreActions="[]"
                                @edit="editPart(part.codpart)"
                                @view="editPart(part.codpart)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="part.nomemun || part.uf">
                            <span class="nb-card-detail-label">Localização</span>
                            <strong><i class="fa fa-map-marker text-muted mr-1" aria-hidden="true"></i>{{ part.nomemun }} <span v-if="part.uf">/ {{ part.uf }}</span></strong>
                        </div>

                        <div class="nb-card-detail" v-if="part.fone1 || part.fone2 || part.fone3">
                            <span class="nb-card-detail-label">Telefone</span>
                            <strong><i class="fa fa-phone text-muted mr-1" aria-hidden="true"></i>{{ part.fone1 | formatFone }} <span v-if="part.fone2">{{ part.fone2 | formatFone }}</span></strong>
                        </div>

                        <div class="nb-card-detail" v-if="part.email">
                            <span class="nb-card-detail-label">E-mail</span>
                            <strong><i class="fa fa-envelope text-muted mr-1" aria-hidden="true"></i>{{ part.email }}</strong>
                        </div>

                        <div class="nb-card-detail" v-if="part.iest">
                            <span class="nb-card-detail-label">Inscrição Estadual</span>
                            <strong>{{ part.iest }}</strong>
                        </div>

                        <div class="nb-card-detail" v-if="part.data_ultima_compra">
                            <span class="nb-card-detail-label">Última Compra</span>
                            <strong>{{ part.data_ultima_compra | formatData }}</strong>
                        </div>
                    </div>
                </article>

                <div class="text-center my-3" v-if="nextPage > 0">
                    <button class="btn btn-outline-primary btn-sm" @click="handleMore()">
                        <i class="fa fa-chevron-down mr-1"></i> Exibir mais participantes
                    </button>
                </div>
            </div>

        </div>

        <customer-form v-if="showForm" :crud="crud" :index="codpart" @closeform="closeForm"></customer-form>

    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-subtitle {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code {
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--warning {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-badge--danger {
  color: #991b1b;
  background: #fef2f2;
  border-color: #fecaca;
}

.nb-card-badge--info {
  color: #0369a1;
  background: #f0f9ff;
  border-color: #bae6fd;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/customer-list.vue